import { ApiClient } from '@/services/api.service';
import { ChatResponse, ChatsListResponse, Couples } from '@/types/chat';
import { MessageDto } from '@/types/message';
import { Like, Profile } from '@/types/profile';
import { AxiosError, AxiosHeaders } from 'axios';

export interface VoteProfileDto {
    value: boolean;
    swipe_time?: number;
}

interface ComplainProfileDto {
    reason: string;
}

class ProfilesApi {
    async getAll() {
        const data = await ApiClient.get<{ profiles: Profile[], swipe_limit_reached: boolean }>(`/profiles/`);
        return data;
    }

    async voteProfileById(profileId: number, voteProfileDto: VoteProfileDto) {
        const data = await ApiClient.post<any>('/swipes/', {
            ...voteProfileDto,
            other_id: profileId
        });
        return data;
    }

    // Убрать голос
    async unvoteProfileById(profileId: number | string) {
        const data = await ApiClient.post<any>(`/profiles/${profileId}/unvote`);
        return data;
    }

    // Удалить из пар TODO еще не готово
    async deleteProfileById(profileId: number | string) {
        const data = await ApiClient.post<any>(`/profiles/${profileId}/delete`);
        return data;
    }

    // Пожаловаться на профиль
    async complainProfileById({ profileId, reason }: { profileId: number | string; reason: string }) {
        const data = await ApiClient.post<ComplainProfileDto>(`/profiles/${profileId}/complain`, { reason });
        return data;
    }

    // Заблокировать профиль
    async blockProfileById(profileId: number | string) {
        const data = await ApiClient.post<any>(`/profiles/${profileId}/block`);
        return data;
    }

    // За кого я голосовал
    async getVotes() {
        const data = await ApiClient.get<any>(`/profile/votes`);
        return data;
    }

    // Лайкнувшие (требуют платный профиль)
    async getLikeMe() {
        const data = await ApiClient.get<LikeMeResponse>(`/received_swipes`);
        return data;
    }

    async getMessagesById(chatId: number | string) {
        const data = await ApiClient.get<ChatResponse>(`/chats/${chatId}`);
        return data;
    }

    async getMessagesByIdNext(chatId: number | string, pageNumber: number) {
        const data = await ApiClient.get<ChatResponse>(`/chats/${chatId}?page=${pageNumber}`);
        return data;
    }

    async sendMsg(payload: {
        chat_id: string | number,
        ice_breaker_used?: boolean,
        message: {
            reply_message_id: string | number | null,
            text: string
        }
    }) {
        return await ApiClient.post('/messages', payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    async updateMsg(
        msgId: number | string,
        payload: {
            text?: string,
            is_read?: boolean,
            is_edited?: boolean,
            edited_at?: string,
        }
    ) {
        return await ApiClient.patch(`/messages/${msgId}`, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    async readMsg(msgId: number | string) {
        return await ApiClient.patch(`/messages/${msgId}/is_read`, {}, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    async getChats(pageNumber: number) {
        const data = await ApiClient.get<ChatsListResponse>('/chats', {
            params: {
                page: pageNumber
            }
        });
        return data;
    }

    async getCouple() {
        const data = await ApiClient.get<Couples[]>('/latest_chats');

        return data;
    }

    async getChat(id: string | number) {
        const data = await ApiClient.get<ChatResponse>(`/chats/${id}`);
        return data;
    }

    async getUnreadChatsCount() {
        return ApiClient.get<{ unread_chats_count: number }>('/chats/unread_count');
    }

    async getMsg(id: string | number) {
        const data = await ApiClient.get<MessageDto>(`/messages/${id}`);
        return data;
    }

    async getLikesCounter() {
        return ApiClient.get<{ count: number }>(`/received_swipes/count`);
    }

    async getProfileById(profileId: number | string) {
        return ApiClient.get<GetProfileByIdRes>(`/profiles/${profileId}`);
    }

    async getMyProfile() {
        return ApiClient.get<Profile>('/profile/show_me');
    }

    // clear chat with user by id
    async deleteChatWithUser(profileId: number | string) {
        return ApiClient.post<any>(`/profiles/${profileId}/clear`);
    }

    // вернуться в поиск
    async activate() {
        return ApiClient.post<any>('/profile/activate');
    }

    // скрыть профиль
    async deactivate() {
        return ApiClient.post<any>('/profile/deactivate');
    }

    async selfInitiateVerification() {
        const data = await ApiClient.patch('/verification/');
        return data;
    }

    async getAvailableLangs() {
        const data = await ApiClient.get<AvailableLang[]>('/profile/available_langs');
        return data;
    }
}

export const profilesApi = new ProfilesApi();

export type GetProfileByIdRes = {
    data: {
        profile: Profile,
        chat_id: number
    }
}

export type LikeMeResponse = {
    free: Like[],
    paid: Like[]
}

export interface AvailableLang {
    name: string;
    autonym: string;
}
